module.exports = __webpack_public_path__ + "img/bars.e17309cd.svg";